module.exports = __webpack_public_path__ + "img/brand-kaggle.69653cfc.svg";